import { IServerMap } from './types';

/**
 * 建议使用命令行操作
 * yarn server-map --add https://test.pandateacher.com/biz/passport
 * 注意：不建议在这里配置local配置，local 配置在.local/local.config.js下
 */
export const serverMap: IServerMap = {
  baseServer: {
    baseMap: {
      test: {
        protocol: 'https:', // 不传或者为null时，获取当前页面protocol
        domain: 'pandateacher.com', // 不传或者为null时，获取当前页面domain
        subDomain: 'test', // 不传或者为null时，获取当前页面subDomain
        port: '', // 不传或者为null时，获取当前页面port
        path: '/cleword-explore/surfer-modelling'
      }
    },
    default: true
  },
  fcSigninServer: {
    baseMap: {
      test: {
        protocol: 'https:',
        domain: 'cleword.cn',
        path: '/biz',
        port: '',
        subDomain: 'test'
      },
      prod: {
        protocol: 'https:',
        domain: 'cleword.cn',
        path: '/biz',
        port: '',
        subDomain: ''
      }
    }
  },

  pmsServer: {
    baseMap: {
      test: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/manage/pms/api/v1',
        port: '',
        subDomain: 'test'
      },
      prod: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/manage/pms/api/v1',
        port: '',
        subDomain: 'prod'
      }
    }
  },
  timelineServer: {
    baseMap: {
      prod: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/biz/timeline/api/v1',
        port: '',
        subDomain: 'prod'
      },
      test: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/biz/timeline/api/v1',
        port: '',
        subDomain: 'test'
      }
    },
    default: true
  },
  manageTimelineServer: {
    baseMap: {
      test: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/manage/timeline/api/v1',
        port: '',
        subDomain: 'test'
      },
      prod: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/manage/timeline/api/v1',
        port: '',
        subDomain: 'prod'
      }
    },
    default: true
  },
  sandboxServer: {
    baseMap: {
      prod: {
        protocol: 'https:',
        domain: 'cleword.cn',
        path: '/biz/sandbox/api/v1',
        port: '',
        subDomain: ''
      },

      test: {
        protocol: 'https:',
        domain: 'cleword.cn',
        path: '/biz/sandbox/api/v1',
        port: '',
        subDomain: 'test'
      }
    }
  },
  runtimeServer: {
    baseMap: {
      prod: {
        // todo
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/biz/sandbox/api/v1',
        port: '',
        subDomain: 'prod'
      },

      test: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/runtime',
        port: '',
        subDomain: 'clienta-admin'
      }
    }
  },
  originServer: {
    baseMap: {
      test: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/biz/zeus/api/v1',
        port: '',
        subDomain: 'test'
      },
      prod: {
        protocol: 'https:',
        domain: 'pandateacher.com',
        path: '/biz/zeus/api/v1',
        port: '',
        subDomain: 'prod'
      }
    }
  }
};
